import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuthenticationService } from './authentication.service';
import { Baseservice } from './baseservice';

@Injectable()
export class WorkflowdashboardService extends Baseservice{

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('dashboard', http, authentication);
  }
  getDashBoard()
  {
      return  this.getRequest(`${this.workflowApiUrl}`);
  }
}
